// extracted by mini-css-extract-plugin
export default {"root":"PromptList_root__+vMyx"};